import type { StorageUsage } from "../../api/types";

/** Espace de stockage de la licence (décision d'Alexis du 02/10/2026 : jauge « Espace utilisé : x sur y », 5 Go par
 *  défaut, réglable côté serveur). Tailles en unités décimales, comme le serveur (`storage.format_bytes`) : « 820 Ko »,
 *  « 1,2 Go » en français, « 820 KB », « 1.2 GB » en anglais. */

const UNITS: Record<"fr" | "en", [string, number][]> = {
  fr: [
    ["To", 1e12],
    ["Go", 1e9],
    ["Mo", 1e6],
    ["Ko", 1e3],
  ],
  en: [
    ["TB", 1e12],
    ["GB", 1e9],
    ["MB", 1e6],
    ["KB", 1e3],
  ],
};

export function formatBytes(n: number, language: "fr" | "en"): string {
  const value = Math.max(0, Number.isFinite(n) ? n : 0);
  for (const [unit, size] of UNITS[language]) {
    if (value >= size) {
      const number = value / size;
      const text = (number < 10 ? number.toFixed(1) : number.toFixed(0)).replace(/\.0$/, "");
      return `${language === "fr" ? text.replace(".", ",") : text} ${unit}`;
    }
  }
  return `${Math.round(value)} ${language === "fr" ? "o" : "B"}`;
}

/** Remplissage de la jauge (0 à 1) et son ton : `warn` au-delà de 85 %, `danger` plein. */
export function gaugeLevel(usage: Pick<StorageUsage, "used_bytes" | "limit_bytes">): { ratio: number; tone: "ok" | "warn" | "danger" } {
  const ratio = usage.limit_bytes > 0 ? Math.min(1, usage.used_bytes / usage.limit_bytes) : 1;
  return { ratio, tone: ratio >= 1 ? "danger" : ratio >= 0.85 ? "warn" : "ok" };
}
